module.exports = __webpack_public_path__ + "img/process-icon.5033408f.svg";